/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Test_Invite_HintInputs */

const th_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดลิงก์นี้บนอีกอุปกรณ์ ใช้แต่ละลิงก์ในเบราว์เซอร์เดียวเท่านั้น`)
};

const en_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this link on the other device. Use each link in one browser only.`)
};

const ja_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`別の端末でこのリンクを開いてください。各リンクは1つのブラウザでご利用ください。`)
};

const zh_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在另一台设备上打开此链接。每个链接只在一个浏览器中使用。`)
};

const es_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre este enlace en el otro dispositivo. Usa cada enlace en un solo navegador.`)
};

const pt_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra este link no outro dispositivo. Use cada link em um só navegador.`)
};

const id_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka tautan ini di perangkat lain. Pakai setiap tautan hanya di satu peramban.`)
};

const fr_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez ce lien sur l’autre appareil. Utilisez chaque lien dans un seul navigateur.`)
};

const tl_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan ang link na ito sa kabilang device. Gamitin ang bawat link sa iisang browser lamang.`)
};

const vi_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở liên kết này trên thiết bị kia. Mỗi liên kết chỉ dùng ở một trình duyệt.`)
};

const ko_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 링크를 다른 기기에서 여세요. 각 링크는 브라우저 하나에서만 쓰세요.`)
};

const de_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne diesen Link auf dem anderen Gerät. Nutze jeden Link nur in einem Browser.`)
};

const ru_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте эту ссылку на другом устройстве. Каждую ссылку используйте только в одном браузере.`)
};

const tr_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu bağlantıyı diğer cihazda açın. Her bağlantıyı yalnızca bir tarayıcıda kullanın.`)
};

const it_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri questo link sull'altro dispositivo. Usa ogni link in un solo browser.`)
};

const pl_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz ten link na drugim urządzeniu. Każdego linku użyj tylko w jednej przeglądarce.`)
};

const uk_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрийте це посилання на іншому пристрої. Кожне посилання використовуйте лише в одному браузері.`)
};

const hi_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह लिंक दूसरे उपकरण पर खोलें। हर लिंक केवल एक ब्राउज़र में उपयोग करें।`)
};

const ar_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح هذا الرابط على الجهاز الآخر. استخدم كل رابط في متصفح واحد فقط.`)
};

const ms_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka pautan ini pada peranti satu lagi. Gunakan setiap pautan dalam satu pelayar sahaja.`)
};

const bn_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই লিঙ্কটি অন্য যন্ত্রে খুলুন। প্রতিটি লিঙ্ক কেবল একটি ব্রাউজারে ব্যবহার করুন।`)
};

const zh_tw2_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在另一台裝置上開啟這個連結。每個連結只在一個瀏覽器中使用。`)
};

const zh_hk2_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在另一台裝置上開啟這個連結。每個連結只在一個瀏覽器中使用。`)
};

const ur_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ لنک دوسرے آلے پر کھولیں۔ ہر لنک صرف ایک براؤزر میں استعمال کریں۔`)
};

const fa_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این پیوند را روی دستگاه دیگر باز کنید. هر پیوند را فقط در یک مرورگر به کار ببرید.`)
};

const sw_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua kiungo hiki kwenye kifaa kingine. Tumia kila kiungo kwenye kivinjari kimoja tu.`)
};

const nl_meeting_test_invite_hint = /** @type {(inputs: Meeting_Test_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open deze link op het andere apparaat. Gebruik elke link in één browser.`)
};

/**
* | output |
* | --- |
* | "Open this link on the other device. Use each link in one browser only." |
*
* @param {Meeting_Test_Invite_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_test_invite_hint = /** @type {((inputs?: Meeting_Test_Invite_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Test_Invite_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_test_invite_hint(inputs)
	if (locale === "ja") return ja_meeting_test_invite_hint(inputs)
	if (locale === "zh") return zh_meeting_test_invite_hint(inputs)
	if (locale === "es") return es_meeting_test_invite_hint(inputs)
	if (locale === "pt") return pt_meeting_test_invite_hint(inputs)
	if (locale === "id") return id_meeting_test_invite_hint(inputs)
	if (locale === "fr") return fr_meeting_test_invite_hint(inputs)
	if (locale === "tl") return tl_meeting_test_invite_hint(inputs)
	if (locale === "vi") return vi_meeting_test_invite_hint(inputs)
	if (locale === "ko") return ko_meeting_test_invite_hint(inputs)
	if (locale === "de") return de_meeting_test_invite_hint(inputs)
	if (locale === "ru") return ru_meeting_test_invite_hint(inputs)
	if (locale === "tr") return tr_meeting_test_invite_hint(inputs)
	if (locale === "it") return it_meeting_test_invite_hint(inputs)
	if (locale === "pl") return pl_meeting_test_invite_hint(inputs)
	if (locale === "uk") return uk_meeting_test_invite_hint(inputs)
	if (locale === "hi") return hi_meeting_test_invite_hint(inputs)
	if (locale === "ar") return ar_meeting_test_invite_hint(inputs)
	if (locale === "ms") return ms_meeting_test_invite_hint(inputs)
	if (locale === "bn") return bn_meeting_test_invite_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_test_invite_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_test_invite_hint(inputs)
	if (locale === "ur") return ur_meeting_test_invite_hint(inputs)
	if (locale === "fa") return fa_meeting_test_invite_hint(inputs)
	if (locale === "sw") return sw_meeting_test_invite_hint(inputs)
	if (locale === "nl") return nl_meeting_test_invite_hint(inputs)
	return en_meeting_test_invite_hint(inputs)
});